import { Controller } from '@hotwired/stimulus';

/**
 * Regional EU/US domain notice: body scroll lock while open.
 * Cookie is set only when the user clicks close or “stay” (not backdrop, Escape, or switch CTA).
 */
export default class extends Controller {
  static values = {
    scenario: String,
    cookieName: String,
    cookieMaxAgeDays: Number,
  };

  connect() {
    this.previousBodyOverflow = document.body.style.overflow;
    queueMicrotask(() => {
      this.element.hidden = false;
      this.element.classList.add('geo-regional-notice--open');
      this.lockBodyScroll();
      const focusEl = this.element.querySelector('[data-geo-regional-notice-autofocus]');
      if (focusEl instanceof HTMLElement) {
        focusEl.focus();
      }
    });
  }

  disconnect() {
    this.unlockBodyScroll();
  }

  dismissAndRemember() {
    this.persistDismiss();
    this.close();
  }

  close() {
    this.element.classList.remove('geo-regional-notice--open');
    this.element.setAttribute('hidden', '');
    this.unlockBodyScroll();
  }

  persistDismiss() {
    const maxAge = Math.floor(this.cookieMaxAgeDaysValue * 86400);
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${this.cookieNameValue}=${encodeURIComponent(this.scenarioValue)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
  }

  backdropClick(event) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  onEscape(event) {
    if (event.key === 'Escape' && !this.element.hidden) {
      this.close();
    }
  }

  lockBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  unlockBodyScroll() {
    document.body.style.overflow = this.previousBodyOverflow || '';
  }
}
